import React from "react";
import {Container, Grid} from "@material-ui/core";
import Page from "../../components/Page";
import CreateSupplierView from "./CreateSupplierView";
import SupplierTable from "./SupplierTable";
import {HasRole} from "../../common/Util";
import {RoleIdEnum} from "../../generated/graphql";

export default () => {
    return (
        <Page title={"supplier page"}>
            <Container maxWidth={false} style={{ padding: "30px"}}>
                <Grid container spacing={2}>
                    <HasRole roles={[RoleIdEnum.Admin, RoleIdEnum.Finance]}>
                        <CreateSupplierView/>
                    </HasRole>
                    <SupplierTable/>
                </Grid>
            </Container>
        </Page>
    )
}